import Variant1 from './Variant1';
import Variant2 from './Variant2';
import Variant3 from './Variant3';
import Variant4 from './Variant4';
import Variant5 from './Variant5';

export const allVariants = [
    {
        id: 0,
        name: 'Style-1',
        element: <Variant1 />
    },
    {
        id: 1,
        name: 'Style-2',
        element: <Variant2 />
    },
    {
        id: 2,
        name: 'Style-3',
        element: <Variant3 />
    },
    {
        id: 3,
        name: 'Style-4',
        element: <Variant4 />
    },
    {
        id: 4,
        name: 'Style-5',
        element: <Variant5 />
    }
];
